import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "../../i18n";

export default function Footer() {
  const location = useLocation();
  const { t } = useTranslation();
  const match = location.pathname.match(/^\/(en|de|it|es|pt)(\/|$)/);
  const langPrefix = match ? `/${match[1]}` : "";

  return (
    <footer className="bg-white border-t border-gray-200 mt-20">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-3">Van-2-Go.ch</h3>
            <p className="text-sm text-gray-600">
              {t("footer.description")}
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3">Contact</h4>
            <div className="space-y-2 text-sm text-gray-600">
              <p>📞 +41 79 960 60 94</p>
              <p>✉️ info@van-2-go.ch</p>
              <p>📍 Montchemin 11, Rebeuvelier, 2832, Jura, Suisse</p>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3">Liens</h4>
            <div className="space-y-2 text-sm">
              <Link 
                to={`${langPrefix}/`} 
                className="block text-gray-600 hover:text-emerald-600"
              >
                {t("navigation.home")}
              </Link>
              <Link 
                to={`${langPrefix}/reserver`} 
                className="block text-gray-600 hover:text-emerald-600"
              >
                {t("navigation.book")}
              </Link>
              <a 
                href="/legal.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="block text-gray-600 hover:text-emerald-600"
              >
                {t("legal.title")}
              </a>
            </div>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200 text-center text-sm text-gray-600">
          © {new Date().getFullYear()} Van-2-Go.ch. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}
